/* unplugin-vue-components disabled */import { render } from "./Resource.vue?vue&type=template&id=766653a4"
const script = {}

import "./Resource.vue?vue&type=style&index=0&id=766653a4&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__